const icon = require('vue-svgicon');

icon.register({
    space: {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: `
            <path d="M17 4C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H12.5V17H11.5V20H7C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44771 4 7 4H17ZM7 19H10.5V16H13.5V19H17V5H7V19ZM9 14H8V12H9V14ZM11 14H10V12H11V14ZM14 14H13V12H14V14ZM16 14H15V12H16V14ZM9 11H8V9H9V11ZM11 11H10V9H11V11ZM14 11H13V9H14V11ZM16 11H15V9H16V11ZM9 8H8V6H9V8ZM11 8H10V6H11V8ZM14 8H13V6H14V8ZM16 8H15V6H16V8Z" />
        `,
    },
});
